import { ArrowLeftIcon } from '@heroicons/react/20/solid';
import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { useGetMatterQuery } from '../../services/api';
import { UpdateMatterForm } from '../matter-form/UpdateMatterForm';

export const UpdateMatterPage: React.FC = () => {
  const navigate = useNavigate();
  const { matter_id } = useParams<{ matter_id: string }>();

  const { data: matterData, isLoading } = useGetMatterQuery(matter_id || '', {
    skip: !matter_id,
  });

  const handleSuccess = (matterId?: string) => {
    navigate(`/matters/${matterId || matter_id}`);
  };

  const handleCancel = () => {
    navigate(`/matters/${matter_id}`);
  };

  if (isLoading) {
    return <div className="grow p-6">Loading...</div>;
  }

  if (!matterData) {
    return <div className="grow p-6">Matter not found</div>;
  }

  return (
    <div className="grow p-6">
      <Link
        to={`/matters/${matter_id}`}
        className="inline-flex items-center gap-1 text-blue-600 hover:text-blue-800 mb-6 font-medium"
      >
        <ArrowLeftIcon className="w-4 h-4" />
        Back to Matter
      </Link>

      <UpdateMatterForm
        matterData={matterData}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </div>
  );
};
